import React from 'react';
import { useToast } from '../hooks/useToast';
import { ToastType } from '../types';

function getToastIcon(type: ToastType): string {
  switch (type) {
    case 'success':
      return 'fa-circle-check';
    case 'error':
      return 'fa-circle-xmark';
    case 'warning':
      return 'fa-triangle-exclamation';
    default:
      return 'fa-circle-info';
  }
}

export default function ToastContainer() {
  const { toasts, removeToast } = useToast();

  return (
    <div className="toast-container">
      {toasts.map(toast => (
        <div key={toast.id} className={`toast ${toast.type}`}>
          <i className={`toast-icon fa-solid ${getToastIcon(toast.type)}`}></i>
          <span className="toast-message">{toast.message}</span>
          <button onClick={() => removeToast(toast.id)} className="toast-close">
            &times;
          </button>
        </div>
      ))}
    </div>
  );
}
